<div class="content-selection-modal-container" *transloco="let t; read: 'contentSelectionModal'">
  <i class="fas fa-chevron-left" (click)="closeContentSelectionModal()"></i>
  <h1 class="content-selection-modal-title">{{ title }}</h1>
  <div *ngIf="(zeroContentState || !hasPublishedContent) && viewStateFullyLoaded" class="content-selection-modal-zero-state">
    <img [src]="'resources/images/content_selection_modal.svg' " alt="{{ 'contentSelectionModal.zeroState.imageAlt' | transloco }}">
    <p *ngIf="zeroContentState" [innerHTML]="t('zeroState.description')"></p>
    <p *ngIf="!hasPublishedContent && !zeroContentState" [innerHTML]="t('contentNonePublishedDescription')"></p>
  </div>
  <p-scrollPanel *ngIf="!zeroContentState"
           [style]="{ height: 'calc(100vh - 307px)'}"
           styleClass="thin-scrollbar"
           class="content-selection-modal-content">
    <!-- Iterate through user's published content to display -->
    <bulb-resume-content-selection-display
      [units]="userPublishedContent"
      [selectionMode]="true"
      [renderResumeSubSectionTileView]="false"
      (onUnitSelected)="handleSelectedUnits( $event )">
    </bulb-resume-content-selection-display>
  </p-scrollPanel>
  <div *ngIf="hasPublishedContent"
     class="content-selection-modal-footer">

    <button class="content-selection-modal-cancel"
        (click)="closeContentSelectionModal()">
      <p>{{ 'cancelButton' | transloco }}</p>
    </button>

    <aero-button
	  (onClick)="closeContentSelectionModalOnSelect()"
	  [disabled]="!userHasSelectedContent"
	  [size]="buttonSize"
	  labelCode="button_select"
	  styleClass="content-selection-modal-save">
    </aero-button>
  </div>
</div>

